//formats date to string 'dd-MM-yyyy HH:mm:ss'
export const formatDateToString = (date) => {
  if (!date) return null
  let dateLocaleString = date.toLocaleString()
  return dateLocaleString.replace(/\./g, '-').replace(',', '')
}